import type { HeroSlide } from "@/types/content";

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-01",
    label: "焦点推荐",
    title: "星海回声",
    subtitle:
      "一段来自深空的循环信号，藏着人类未来的答案。国产科幻年度话题之作。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20still%20of%20a%20vast%20starry%20ocean%20reflecting%20a%20distant%20glowing%20planet%2C%20deep%20navy%20blue%20sky%20with%20warm%20orange%20rim%20light%2C%20atmospheric%20sci-fi%20mood%2C%20minimal%20composition%2C%20soft%20gradient%20background%2C%20high%20detail%20cinematic%20color%20grading&width=1600&height=900&seq=hero-01&orientation=landscape",
    link: "/detail/film/film-01",
  },
  {
    id: "hero-02",
    label: "热播口碑",
    title: "长夜将明",
    subtitle:
      "退休前最后七天，一桩尘封十五年的旧案重新浮出水面。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20still%20of%20a%20rainy%20neon%20city%20street%20at%20night%2C%20lone%20silhouetted%20figure%20with%20umbrella%2C%20deep%20blue%20shadows%20with%20warm%20amber%20street%20lights%2C%20moody%20noir%20atmosphere%2C%20soft%20bokeh%20background%2C%20high%20detail%20cinematic%20color%20grading&width=1600&height=900&seq=hero-02&orientation=landscape",
    link: "/detail/film/film-02",
  },
  {
    id: "hero-03",
    label: "年代史诗",
    title: "山河故人梦",
    subtitle:
      "一座古城的兴衰，三代人的离散与重逢，写尽百年家国记忆。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20still%20of%20misty%20ancient%20mountain%20ranges%20at%20golden%20dawn%2C%20historical%20epic%20landscape%20with%20distant%20pagoda%2C%20deep%20blue%20haze%20with%20warm%20orange%20sunrise%20light%2C%20painterly%20atmosphere%2C%20minimal%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-03&orientation=landscape",
    link: "/detail/film/film-03",
  },
  {
    id: "hero-04",
    label: "青春热血",
    title: "追风少年",
    subtitle:
      "小镇少年凭一股不服输的劲头，跑进了国家队的跑道。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20still%20of%20young%20runners%20sprinting%20on%20a%20coastal%20road%20at%20sunset%2C%20dynamic%20motion%20blur%2C%20deep%20blue%20sea%20with%20warm%20orange%20sky%2C%20energetic%20youthful%20mood%2C%20minimal%20composition%2C%20high%20detail%20cinematic%20grading&width=1600&height=900&seq=hero-04&orientation=landscape",
    link: "/detail/film/film-05",
  },
  {
    id: "hero-05",
    label: "视觉大片",
    title: "深海秘境",
    subtitle:
      "科考队潜入万米海沟，发现了一座仍在运转的远古遗迹。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20still%20of%20a%20deep%20sea%20underwater%20scene%20with%20glowing%20jellyfish%20and%20dark%20blue%20water%2C%20warm%20orange%20bioluminescent%20accents%2C%20mysterious%20adventurous%20mood%2C%20minimal%20composition%2C%20high%20detail%20cinematic%20color%20grading&width=1600&height=900&seq=hero-05&orientation=landscape",
    link: "/detail/film/film-12",
  },
];

export const hotTags: string[] = [
  "星海回声",
  "长夜将明",
  "国庆档票房",
  "林知遥",
  "沈亦舟转型导演",
  "年代剧回潮",
  "悬疑克制叙事",
  "深海秘境特效",
  "老戏骨",
  "演技瞬间",
  "时光信箱",
  "追风少年",
];

export const siteStats = [
  { label: "收录影视作品", value: "1,280+" },
  { label: "明星人物资料", value: "680+" },
  { label: "网络话题追踪", value: "3,500+" },
  { label: "日均更新条目", value: "120+" },
];